<template>
    <uw-page title="合同附件">
        <template slot="header-suffix">
            <contract-button-files-upload @onChange="Search" :contract_id="contract.id" />
        </template>
        <files-table v-model="contract.files_id" />
    </uw-page>
</template>
<script>
export default {
    props: [ 'contract_id', 'customer_id' ],
    data () {
        return {
            contract: {
                id: null,
                source: [],
                customer: {},
                project: {},
                time_limit: [],
                user_admin: {},
                user_affair: {},
                user_presale: {},
                user_sale: {},
                files_id: []
            }
        }
    },
    watch: {
        contract_id: {
            handler(val) {
                if(val) {
                    this.Search()
                }
            },
            immediate: true
        }
    },
    methods: {
                Search() {
            this.$http.post(
                '/9api/crm/contract/search-first',
                {
                    id: this.contract_id,
                    hidden: ['describe']
                }
            ).then(rps => {
                this.contract = rps.data
            })
        },
    }
}
</script>